var React = require('react');

function PlaybuttonMini (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M.121 19c0-10.493 8.507-19 19-19s19 8.507 19 19-8.507 19-19 19-19-8.507-19-19","key":0}),React.createElement("path",{"fill":"#fff","stroke":"#fff","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1.5","d":"m24.621 19-9 6V13z","key":1})]);
}

PlaybuttonMini.defaultProps = {"width":"39","height":"38","fill":"#9253A1","viewBox":"0 0 39 38"};

module.exports = PlaybuttonMini;

PlaybuttonMini.default = PlaybuttonMini;
